import { getValueOrDefaultObject, isEmptyEvery, isEmptyObject, ParseJsonSafely } from 'common/utilities/utils';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import FavouriteMenuCard from './FavouriteMenuCard';
import { UserOrderContext } from 'context/context';
import { MENU_PLP_CONSTANT_DATA } from 'common/utilities/menuPLPModulator';

const FavouriteMenuComponent = props => {
  const { limitSize, checkProductAvailabity, availableProductPrice, getPrice } = props;
  const { userOrderState } = useContext(UserOrderContext);
  const [isStoreClosed, setIsStoreClosed] = useState(false);
  const checkAvailablity = () => {
    return getList(
      from,
      to,
      initialInterval,
      asap?.isAvailable,
      futureDates?.length === 1 && country?.toUpperCase() === MENU_PLP_CONSTANT_DATA.INDIA,
      unavailibilities,
    );
  };
  const storeInfo = useMemo(() => {
    return isEmptyEvery(userOrderState.currentStoreInfo)
      ? ParseJsonSafely(localStorage.getItem('currentStoreInfo'))
      : userOrderState.currentStoreInfo;
  }, [userOrderState.currentStoreInfo]);
  const { futureDates, scheduled: initiallyScheduled, asap } = getValueOrDefaultObject(storeInfo?.summary?.timings);
  const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
  const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
    initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
  );
  const { from, to } = startEndTime;
  const updateStoreStatus = useCallback(() => {
    if (isEmptyObject(storeInfo)) {
      let storeStatus = storeInfo.summary?.status?.currentStatus;
      let availableSlots = checkAvailablity();
      if (storeStatus === 'CLOSED' && !availableSlots.length) {
        setIsStoreClosed(true);
      } else {
        setIsStoreClosed(false);
      }
    } else {
      setIsStoreClosed(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeInfo]);

  useEffect(() => {
    updateStoreStatus();
  }, [updateStoreStatus]);
  const { country = '', currencySymbol, maxItemCountPerLineItem } = useSelector(data => data.tenantReducer || {});
  const favouriteItems = useSelector(data => data.profileReducer?.favouriteItems || []);
  const customerId = useSelector(data => data.profileReducer?.basic?.id || '');
  const { flatResponse: { itemMapById = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  return (
    <React.Fragment>
      {favouriteItems.slice(0, limitSize).map(product => {
        const catalogData = itemMapById?.[product.id];
        const isProductAvailable = checkProductAvailabity(product.id);
        const properties = catalogData?.additionalProperties ?? product?.additionalProperties;
        const cataloguePrice = getPrice(availableProductPrice(product.id));
        const differencePrice = product.price - cataloguePrice;
        const additionalProperties = properties?.reduce(
          (acc, { key, value }) =>
            (acc = {
              ...acc,
              [key]: value === 'True' ? true : value === 'False' ? false : value,
            }),
          {},
        );
        return (
          <FavouriteMenuCard
            isProductAvailable={isProductAvailable}
            catalogueData={catalogData}
            maxItemCountPerLineItem={maxItemCountPerLineItem}
            product={product}
            customerId={customerId}
            differencePrice={differencePrice}
            currencySymbol={currencySymbol}
            additionalProperties={additionalProperties}
            {...props}
            data-testid={`favourite-menu-card-${product.id}`}
            storeClosedData={{ isStoreClosed }}
          />
        );
      })}
    </React.Fragment>
  );
};

export default FavouriteMenuComponent;
